import { Component, Input } from '@angular/core';
import { Store } from '@ngxs/store';
import { EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ShowError } from '../../../../../core/state/notification/notification.actions';
import { StorageDirectUrl, StorageFile } from '../../../../../types/FileDownload';
import { LoggerService } from '../../../../shared/services/logger.service';
import { RestService } from '../../../../shared/services/rest.service';
import { StorageService } from '../../../../shared/services/storage.service';
import { ReportDocumentField } from '../../../state/report.model';
import { MatButton } from '@angular/material/button';
import { NgClass } from '@angular/common';
import { ClassDirective } from '@ngbracket/ngx-layout';

@Component({
    selector: 'dash-gis-document-link-field',
    templateUrl: './document-link-field.component.html',
    styleUrls: ['./document-link-field.component.scss'],
    imports: [MatButton, NgClass, ClassDirective],
})
export class DocumentLinkFieldComponent {
    @Input() rowData: any;
    @Input() fieldDefinition: ReportDocumentField;
    @Input() asLink = true;

    constructor(
        private logger: LoggerService,
        private store: Store,
        private rest: RestService,
        private storageService: StorageService
    ) {}

    getFile() {
        const path = this.rowData[this.fieldDefinition.documentPath];
        this.rest
            .apiGet<StorageFile | StorageDirectUrl>('document', { path })
            .pipe(
                take(1),
                switchMap((storageObject) => {
                    if (storageObject['content'] !== undefined) {
                        return this.storageService.handleBlob(storageObject as StorageFile);
                    } else if (storageObject['url'] !== undefined) {
                        return this.storageService.handleUrl(storageObject as StorageDirectUrl);
                    } else {
                        this.store.dispatch(new ShowError('Invalid response when retrieving file.'));
                        return EMPTY;
                    }
                })
            )
            .subscribe();
    }
}
